import { styled } from "@vitality-ds/system";
import BaseShortcutStyles from "./styles/BaseShortcut.styles";
import BaseShortcutGroupStyles from "./styles/BaseShortcutGroup.styles";
export var BaseShortcut = styled("kbd", BaseShortcutStyles);
export var BaseShortcutGroup = styled("kbd", BaseShortcutGroupStyles);